<template>
  <div class="right-content">
    <div class="certificate-page">
      <div class="page-header">
        <h3>我的证书</h3>
      </div>

      <div v-loading="loading" class="certificate-list">
        <div v-if="list.length === 0 && !loading" class="empty-tip">
          <el-empty description="暂无证书记录" />
        </div>
        <div v-for="(item, index) in list" :key="index" class="certificate-card">
          <div class="card-left">
            <div class="cert-img" v-if="item.certificate_img">
              <el-image
                :src="item.certificate_img"
                fit="cover"
                :preview-src-list="[item.certificate_img]"
                class="cert-thumbnail"
              />
            </div>
            <div class="cert-icon" v-else>
              <svg viewBox="0 0 24 24" width="32" height="32" fill="#1e9dd4">
                <path d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm-1 15l-4-4 1.41-1.41L11 14.17l6.59-6.59L19 9l-8 8z"/>
              </svg>
            </div>
            <div class="cert-info">
              <div class="cert-no">证书编号：{{ item.certificate_no || '-' }}</div>
              <div class="cert-date">发证日期：{{ item.issue_time || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import certificate from "@/api/certificate";

export default {
  name: "my_certificate",
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const res = await certificate.myList();
        if (res && res.data) {
          this.list = Array.isArray(res.data) ? res.data : (res.data.list || []);
        }
      } catch (err) {
        this.$message.error(err.msg || '获取证书列表失败');
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.right-content {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
  h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
}

.certificate-list {
  min-height: 200px;
}

.certificate-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 12px;
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }

  .card-left {
    display: flex;
    align-items: center;

    .cert-icon {
      width: 56px;
      height: 56px;
      background: #e8f6fc;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      flex-shrink: 0;
    }

    .cert-img {
      width: 80px;
      height: 80px;
      margin-right: 16px;
      flex-shrink: 0;
      border-radius: 6px;
      overflow: hidden;

      .cert-thumbnail {
        width: 80px;
        height: 80px;
      }
    }

    .cert-info {
      .cert-no, .cert-date {
        font-size: 13px;
        color: #999;
        line-height: 1.8;
      }
    }
  }
}

.empty-tip {
  padding: 60px 0;
  text-align: center;
}
</style>
